import protoRoot from "../proto-root";

const name = "stopMonitoringFromCameraStationRPCRequest";

function create() {
  const StopMonitoringFromCameraStationRPCRequest = protoRoot.lookupType(
    "comm.StopMonitoringFromCameraStationRPCRequest"
  );
  const request = StopMonitoringFromCameraStationRPCRequest.create();
  return { payload: request, name };
}

const stopMonitoringFromCameraStationRpcRequest = { create, name };

export default stopMonitoringFromCameraStationRpcRequest;
